import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 34px;
  padding-left: 15px;
`;
Wrapper.displayName = 'Wrapper';

export const Label = styled.div`
  font-size: 14px;
  color: #8f94b2;
  text-align: left;
  margin-bottom: 7px;
`;
Label.displayName = 'Label';

export const Input = styled.input`
  padding: 10px 16px 10px 16px;
  box-shadow: inset 0 -1px 0 0 #cfd1de;
  background-color: ${colors.iceBlue};
  font-size: 13.5px;
  color: #090909;
  border: 0;
`;
Input.displayName = 'Input';
